import UserViewContainer from './containers/UserViewPageContainer'

export default UserViewContainer
